import qs from 'qs';
import useAPI from '../core/hooks/useApi';

export const useGetFieldsByOptInId = optInId => useAPI(`/api/fields?${qs.stringify({ optInId })}`);
